module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-TRIAL3-if-correct.50b5f09d.mp3";